import { ICartItem } from 'src/app/storage-user/models/cart-item.model';
import { ProcurementArea } from '../enums/procurement-area.enum';
import { IOrderLineRequest } from '../models/order-line.model';

export function getCartOrderLineOverlaps(
  cartItems: ICartItem[],
  orderLines: IOrderLineRequest[]
): ICartItem[] {
  return cartItems.filter((item) =>
    orderLines.some((line) => isStorageOrderLineForCartItem(line, item))
  );
}

export function isStorageOrderLineForCartItem(
  orderLine: IOrderLineRequest,
  cartItem: ICartItem
): boolean {
  const storageProductId = orderLine.storageProduct?.id || orderLine.storageProductId;
  return (
    orderLine.procurementArea === ProcurementArea.Storage && storageProductId === cartItem.productId
  );
}
